import { useState } from "react";
import Signature from "../Signature/Signature";
import API from "../../services/API";
import { Alert, Divider, Stack, Typography } from "@mui/material";
import Loader from "../Tools/Loader";
import { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import { Lock } from "@mui/icons-material";

export default function PiSignatureForm({ id }){

    const [signature, setSignature] = useState(null)

    const [status, setStatus] = useState('loading')

    useEffect(() => {

        API.get(`/signatures/pi/${id}`)
            .then(r => {
                console.log('Signature : ', r.data)
                setStatus('sign')
                setSignature(r.data)
            })
            .catch(_ => setStatus('ready'))

    }, [id])

    const handleCreate = () => {

        setStatus('creating')
        
        API.post(`/dpc/registrations/${id}/signature`) 
            .then(r => {
                setSignature(r.data)
                setStatus('sign')
            })
            .catch(e => {
                console.log(e.response?.status, e.response?.data)
                setStatus('error')
            })
    }

    return <>

        {['ready', 'creating', 'error'].includes(status) && 

            <Stack sx={{maxWidth: 500, margin: 'auto'}} spacing={3}>

                <Typography variant='h4'>
                    Signez votre Attestation de Participation
                </Typography>

                <Divider />

                <Typography>
                    Cette formalité est indispensable pour officialiser votre participation et bénéficier de la prise en charge.
                </Typography>

                {status === 'error' && 
                    <Alert severity="error" icon={<Lock />}>
                        Accès au document non autorisé.
                    </Alert>
                }

                <LoadingButton 
                    variant='outlined' 
                    onClick={handleCreate}
                    loading={status === 'creating'}
                >
                    Accéder au document
                </LoadingButton>

            </Stack>
        }

        
        
        {status === 'sign' && 
            <Signature data={signature} />
        }

        {status === 'loading' && 
            <Loader />
        }

    </>


}